import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import RadioGroupField from 'components/RadioGroupField';
import useDraftListingOptions, {
  LISTING_TYPE_FLOW,
} from 'hooks/useDraftListingOptions';
import { ImField } from 'components/ImField';
import { useFormState } from 'react-final-form';
import { YesNo } from 'models/Fields';
import { CREATE_LISTING_OPTIONS } from 'models/DealRoom';

import './DraftListingFields.styles.scss';
import './DraftListingFields.styles.responsive.scss';

type DraftListingFieldsProps = {
  className?: string;
  dealRoomId: string;
  dealName?: string;
  fieldName: string;
  basedOnFieldName?: string;
};

const DraftListingFields: React.FC<DraftListingFieldsProps> = (props) => {
  const { className, dealRoomId, dealName, fieldName, basedOnFieldName } =
    props;

  const { createListingOptions, draftListingOptions, listingTypeOptions } =
    useDraftListingOptions();

  const { values } = useFormState();

  const value = values[fieldName];
  const showDraftListingOptions = basedOnFieldName
    ? values[basedOnFieldName] === CREATE_LISTING_OPTIONS.DRAFT_LISTING
    : true;

  const classes = classNames('draft-listing-fields', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      {basedOnFieldName && (
        <RadioGroupField
          name={basedOnFieldName}
          options={createListingOptions}
          styled
        />
      )}

      {showDraftListingOptions && (
        <>
          <p className="draft-listing-fields__description">
            {t('wouldYouLikeAiToDraft')}
          </p>

          <RadioGroupField
            name={fieldName}
            options={draftListingOptions}
            styled
          />

          {value === YesNo.Yes && (
            <>
              <p className="draft-listing-fields__description">
                {t('whatIsListingType')}
              </p>

              <RadioGroupField
                name={LISTING_TYPE_FLOW}
                options={listingTypeOptions}
                styled
              />

              <ImField dealRoomId={dealRoomId} dealName={dealName} />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default DraftListingFields;
